import { createAction } from '@reduxjs/toolkit'

import { BaseRepayNowState } from './types'

export const resetSelectedRepayNowAction = createAction<void>('repay-now/reset-selected-payment')
export const setSelectedRepayNowAction = createAction<
  { paymentAmount?: number } & Omit<BaseRepayNowState, 'paymentAmount'>
>('repay-now/set-selected-payment')
